import React, { useContext } from "react";
import {
  OurClientTheme,
  THEME_UPDATE_MESSAGE,
  ThemeNo,
} from "../../../../constant";
import OurClientContext from "../../../context/OurClientContext/OurClientContext";
import OurClientTheme1 from "./OurClientTheme1";
import OurClientTheme2 from "./OurClientTheme2";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { putUpdateOurClient } from "../apis/OurClientApi/OurClientApi";
import { Button, Col, Container, Row } from "reactstrap";
import { ourClientStyleOne, ourClientStyleTwo } from "./ourClientStyleFunction";
import { TostMessage } from "../../../utils";
import OurClient1 from "../ScreenShorts/OurClient/OurClient1.png";
import OurClient2 from "../ScreenShorts/OurClient/OurClient2.png";
import ThemeImageShow from "../../../common/ThemeImageShow";

const SettingOurClientParentPopup = (props) => {
  const {
    id,
    setTheme,
    setSettingFormData,
    theme,
    setBoxSection,
    setBackImageToggle,
    setIsBackgroundColor,
    imgShow,
    setImgShow,
  } = useContext(OurClientContext);
  const { setLoaderShow } = useContext(LoaderContext);
  const { imageUpload, handleSubmitSetting, handleChangeSettings } = props;

  const resetHandler = () => {
    let setStyle;
    if (theme === ThemeNo.ThemeOne) {
      setStyle = ourClientStyleOne;
    } else if (theme === ThemeNo.ThemeTwo) {
      setStyle = ourClientStyleTwo;
    }
    setSettingFormData({ ...setStyle });
    setBackImageToggle(false);
    setBoxSection(false);
    setIsBackgroundColor(true);
  };
  const handleTheme = async (e) => {
    setLoaderShow(true);
    const { value } = e.target;
    setTheme(value);
    try {
      let formData = {
        theme: value,
        ourClientId: id,
      };
      const { data } = await putUpdateOurClient(formData);
      if (data.status === 200) {
        await handleChangeSettings(id, true);
        TostMessage({
          message: { message: THEME_UPDATE_MESSAGE },
          type: "success",
        });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    } finally {
      setLoaderShow(false);
    }
  };

  const handleClose = () => {
    setImgShow(false);
  };
  const themeImg = {
    1: OurClient1,
    2: OurClient2,
  };

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center position-relative">
              <div
                className="d-flex justify-content-between position-sticky"
                style={{ top: "87px", background: "white", zIndex: 999 }}
              >
                <h6>{"Edit"}</h6>
                <div className="d-flex gap-2">
                  <Button onClick={resetHandler}>Reset</Button>
                  <Button onClick={() => handleSubmitSetting(true)}>
                    Restore
                  </Button>
                  <Button
                    onClick={() => handleSubmitSetting(null, false)}
                    color="success"
                  >
                    Save & View
                  </Button>
                </div>
              </div>

              <Row>
                <Col>
                  <label htmlFor="">Theme</label>
                  <select
                    name="theme"
                    id="font-weight"
                    className="form-select"
                    value={theme}
                    onChange={(e) => handleTheme(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value={1}>Theme 1</option>
                    <option value={2}>Theme 2</option>
                  </select>
                </Col>
              </Row>
              {!imgShow && (
                <div>
                  <Button
                    onClick={() => setImgShow(true)}
                    color="primary"
                    className="mt-2"
                  >
                    Show Theme Image
                  </Button>
                </div>
              )}
              {imgShow && (
                <ThemeImageShow
                  themeImg={themeImg[theme]}
                  handleClose={handleClose}
                />
              )}
              {+theme === OurClientTheme.theme1 && (
                <OurClientTheme1
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )}
              {+theme === OurClientTheme.theme2 && (
                <OurClientTheme2
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SettingOurClientParentPopup;
